'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useInstantSearch } from 'react-instantsearch';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import avo from 'analytics/avo';
import useUserCurrentPageType from 'hooks/useUserCurrentPageType';
import { getAdvancedSearchUrlForQueryAndIndex } from '../../../commons/helpers';
import ResultsHeader from './components/ResultsHeader';

/**
 * ResultsByCategory component for Next version (v7)
 * Uses Index widgets with useHits hook for multi-index search
 */
const ResultsByCategoryNext = t0 => {
  const $ = _c(11);
  const {
    toggleSearchOpen,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "desktop" : t1;
  const {
    results
  } = useInstantSearch();
  const query = results?.query || "";
  const currentPage = useUserCurrentPageType();
  if (!query || !results) {
    return null;
  }
  let t2;
  if ($[0] !== variant) {
    t2 = <ResultsHeader variant={variant}>View results by:</ResultsHeader>;
    $[0] = variant;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== currentPage || $[3] !== query || $[4] !== results.nbHits || $[5] !== toggleSearchOpen || $[6] !== variant) {
    t3 = results.nbHits > 0 && <Link to={getAdvancedSearchUrlForQueryAndIndex(query, "products")} onClick={async () => {
      await toggleSearchOpen();
      avo.productsSearched({
        query,
        location: currentPage,
        searchTarget: avo.SearchTarget.OTHER_RESULTS_LINK
      });
    }} className={classNames("text-sm font-bold mt-1 mb-1 ml-0 no-underline !leading-[1.5rem] active:bg-gray-light8 focus:bg-gray-light8 hover:bg-gray-light8", {
      "block mr-2.5 text-[#585858]": variant === "desktop"
    })}>Products ({results.nbHits})</Link>;
    $[2] = currentPage;
    $[3] = query;
    $[4] = results.nbHits;
    $[5] = toggleSearchOpen;
    $[6] = variant;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
ResultsByCategoryNext.propTypes = {
  toggleSearchOpen: PropTypes.func,
  variant: PropTypes.string
};
export default ResultsByCategoryNext;